import useMutation from "src/hooks/useMutation";

function useCustomerAddressCreate(id) {
  return useMutation({
    path: `/api/v1/customers/${id}/addresses`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/customers/${id}/addresses`,
      shouldRevalidate: true,
    },
  });
}

export default useCustomerAddressCreate;
